export default __webpack_public_path__ + "static/media/Websites-MitM(2).219c5a5e.png";